import React, { FC } from "react";

import { HStack } from "@UI/Components/Stack/Stack";
import { Icon } from "@UI/Components/Icon/Icon";
import { Facebook as FacebookIcon } from "@UI/Components/Icons/Facebook";
import { Instagram as InstagramIcon } from "@UI/Components/Icons/Instagram";
import { Vimeo as VimeoIcon } from "@UI/Components/Icons/Vimeo";
import { LinkedIn as LinkedInIcon } from "@UI/Components/Icons/LinkedIn";
import { Twitter as TwitterIcon } from "@UI/Components/Icons/Twitter";

import { RouterLink } from "@Libs/Router/Components/RouterLink/RouterLink";

const _hover = { transform: "translateY(-5px)", color: "inherit" };

export const SocialLinks: FC = () => {
  return (
    <HStack spacing="4">
      <RouterLink _hover={_hover} reloadDocument route="FACEBOOK">
        <Icon as={FacebookIcon} height="6" width="6" color="gray.800" />
      </RouterLink>
      <RouterLink _hover={_hover} reloadDocument route="INSTAGRAM">
        <Icon as={InstagramIcon} height="6" width="6" color="gray.800" />
      </RouterLink>
      <RouterLink _hover={_hover} reloadDocument route="VIMEO">
        <Icon as={VimeoIcon} height="6" width="6" color="gray.800" />
      </RouterLink>
      <RouterLink _hover={_hover} reloadDocument route="TWITTER">
        <Icon as={TwitterIcon} height="6" width="6" color="gray.800" />
      </RouterLink>
      <RouterLink _hover={_hover} reloadDocument route="LINKEDIN">
        <Icon as={LinkedInIcon} height="6" width="6" color="gray.800" />
      </RouterLink>
    </HStack>
  );
};
